import React from "react"
import { useTranslation } from "react-i18next"

import { connect } from "scrivito"
import { PortalNewsPageObj } from "scrivito/Objs/PortalNewsPage/PortalNewsPageObjClass"
import { PortalNewsPostObj } from "scrivito/Objs/PortalNewsPost/PortalNewsPostObjClass"

import "./styles/_portal-news-page.scss"
import { ScrivitoPortalNewsListItem } from "./ui/ScrivitoPortalNewsListItem"

export interface ScrivitoPortalNewsListModel {
  page: PortalNewsPageObj | null | undefined
  posts: PortalNewsPostObj[] | null | undefined
  unreadPostIDs: string[] | null | undefined
}

function ScrivitoPortalNewsListComponent({
  page,
  posts,
  unreadPostIDs
}: ScrivitoPortalNewsListModel) {
  const { t } = useTranslation()

  if (!posts || posts.length === 0) {
    return (
      <div className="portal-news-list__no-results">
        {t("PortalNews.NoResults")}
      </div>
    )
  }

  return (
    <ul className="portal-news-list">
      {posts?.map(post => (
        <ScrivitoPortalNewsListItem
          key={post.id()}
          post={post}
          maxPostAgeInDays={page?.get("maxPostAgeInDays")}
          isUnread={unreadPostIDs?.includes(post.id())}
        />
      ))}
    </ul>
  )
}

export const ScrivitoPortalNewsList = React.memo(
  connect(ScrivitoPortalNewsListComponent)
)
